<div fxLayout="row" fxLayoutGap="15px">
  <mat-card
    *ngIf="thumbnailsVisible && !(loadError$ | async)"
    fxFlex="none"
    class="thumbnails-card"
  >
    <mat-card-content>
      <div *ngIf="shouldShowLoadingThumbnals$ | async; else thumbnailsEl">
        <ng-container *ngFor="let pageNumber of pageNumbers">
          <mmx-pdf-thumbnail
            [loading]="true"
            [page]="{ pageNum: pageNumber }"
            [numberOfPages]="numberOfPages"
          ></mmx-pdf-thumbnail>
        </ng-container>
      </div>

      <ng-template #thumbnailsEl>
        <div *ngIf="selectedPages$ | async as selectedPages" fxLayout="column">
          <mmx-pdf-thumbnail
            *ngFor="let page of pages$ | async"
            [page]="page"
            [selected]="selectedPages.has(page.pageNum)"
            [numberOfPages]="numberOfPages"
            (pageSelect)="onPageSelect({ page, event: $event })"
          ></mmx-pdf-thumbnail>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>

  <mat-card fxFlex class="document-card">
    <mat-progress-bar [mode]="(progressVisible$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
    <mat-card-header>
      <ng-content select="[card-header]"></ng-content>
    </mat-card-header>

    <mat-card-content class="pb-0">
      <div class="document-container" fxLayout="column" fxLayoutAlign="top center">
        <mmx-pdf-text-layer
          *ngIf="blocks?.length && width && height"
          [width]="width"
          [height]="height"
          [blocks]="blocks"
          [page]="currentPage"
        >
        </mmx-pdf-text-layer>
        <canvas #pdfCanvas></canvas>

        <div *ngIf="loadError$ | async" class="load-error">
          <mat-icon>broken_image</mat-icon>
          <div>{{ 'pdf-reader.status.load-failed' | translate }}</div>
        </div>

        <div *ngIf="loading$ | async" class="loading-overlay"></div>
      </div>

      <ng-content select="[page-actions]"></ng-content>
    </mat-card-content>
  </mat-card>
</div>
